import { useMemo, useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { useListForHomeQuery } from "../../../api/featuredProduct.api";
import LoadingComponent from "../../../common/Loading/Loading.component";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./FInalSlider.css";
import { mediaPreloader } from "../../../utils/preloader";

// Custom arrow components
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next" onClick={onClick}>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev" onClick={onClick}>
  </div>
);

const FinalSlider = () => {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const productRef = useRef(null)
  const { data, isLoading } = useListForHomeQuery(undefined,{
   // Remove React Query options - RTK Query handles caching differently
   refetchOnMountOrArgChange: false,
   skip: false, // Ensure query runs
  });
  const product = useMemo(() => {
    return data?.result;
  }, [data]);
    // Advanced preloading with batch processing
    useEffect(() => {
      if (product && !assetsLoaded) {
        const preloadAssets = async () => {
          try {
            const assets = [];
            product.forEach(item => {
              assets.push(
                { type: 'image', src: item.desktopImage, priority: 'high' },
                { type: 'image', src: item.mobileImage, priority: 'high' }
              );
            });  
            // Batch preload all assets
            await mediaPreloader.batchPreload(assets);
            setAssetsLoaded(true);
          } catch (error) {
            console.warn('Asset preloading failed:', error);
            setAssetsLoaded(true); // Still show content even if preload fails
          }
        };
  
        preloadAssets();
      }
    }, [product, assetsLoaded]);

  const settings = {
    dots: false, 
    infinite: true, 
    speed: 500, 
    slidesToShow: 1, 
    slidesToScroll: 1, // Number of slides to scroll
    centerMode: true, // Center the active slide
    centerPadding: "10%", // Adjust padding to create the 10% - 80% - 10% layout
    adaptiveHeight: true, // Adjust height dynamically based on content
    nextArrow: <NextArrow />, // Custom right arrow
    prevArrow: <PrevArrow />, // Custom left arrow
  };

  if (isLoading) {
    return <LoadingComponent
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f9f9f9',
      }} 
     />;
  }

  return (
    <div className="slider-container" ref={productRef}>
      {product?.length > 0 ? (
        <Slider {...settings}>
          {product.map((item, index) => (
            <div className="carousel-cell" key={index}>
              <Link to={item.link}>
                <div className="slider-details">
                  <img
                    className="desktopImage"
                    src={item.desktopImage}
                    alt={item.title}
                    loading="lazy"
                  />
                  <img
                    className="mobileImage"
                    src={item.mobileImage}
                    alt={item.title}
                    loading="lazy"
                  />
                  <div className="slider-details-content">
                    <h3>{item.title}</h3>
                    <p>{item.subTitle}</p>
                    <button>Shop now</button>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      ) : (
        <></>
      )}
    </div>
  );
};
export default FinalSlider;